/**
 * MCP server CRUD + tool catalog client.
 *
 * Thin wrappers over `apiFetch` so the Settings page can stay
 * focused on UX and the call sites get typed payloads.
 */
import { tokenStorage } from "@/auth/storage";
import { apiFetch, throwApiRequestError } from "./client";
import type {
  CreateMcpServerRequest,
  McpServerSpec,
  McpToolView,
} from "./generated";

export function listMcpServers(): Promise<McpServerSpec[]> {
  return apiFetch<McpServerSpec[]>("/api/v1/mcp/servers");
}

export function createMcpServer(
  req: CreateMcpServerRequest,
): Promise<McpServerSpec> {
  return apiFetch<McpServerSpec>("/api/v1/mcp/servers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
}

/**
 * DELETE returns 204 No Content, so we bypass `apiFetch` (which expects
 * a JSON body on success).
 */
export async function deleteMcpServer(id: string): Promise<void> {
  const headers: Record<string, string> = { Accept: "application/json" };
  const tokens = tokenStorage.load();
  if (tokens?.access_token) {
    headers.Authorization = `Bearer ${tokens.access_token}`;
  }
  const res = await fetch(`/api/v1/mcp/servers/${encodeURIComponent(id)}`, {
    method: "DELETE",
    headers,
  });
  if (!res.ok) {
    await throwApiRequestError(res);
  }
}

export function listMcpTools(): Promise<McpToolView[]> {
  return apiFetch<McpToolView[]>("/api/v1/mcp/tools");
}

export function listMcpToolsForServer(id: string): Promise<McpToolView[]> {
  return apiFetch<McpToolView[]>(
    `/api/v1/mcp/servers/${encodeURIComponent(id)}/tools`,
  );
}
